module.exports = __webpack_public_path__ + "static/Baggage-second-iteration-2-946cf80295dda9b77f438aa104696551.png";